export function removeNonAlphaCharacters(s: string) {
    return s.replace(/[^a-z]/gi, '');
}
